import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../data/redux/store";
import { fetchTaskDataAction, saveTaskAction } from "../data/redux/actions/TaskActions";
import CommonTextEditor from "../common/textEditor";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import TaskRepetition from "./ticketRepitionModal";
import Select from "react-select";
import dayjs from "dayjs";
import MediaUpload from "./mediaUploader";
import { MODAL_ACTION } from "../data/redux/Dispatchers";
import moment from "moment-timezone";
interface Props {
  task?: any
}
const TicketListModal: React.FC<Props> = ({ task }) => {
  const dispatch = useDispatch<any>();
  const masters = useSelector((state: RootState) => state.admin.masters);
  const actionStatus = useSelector((state: RootState) => state.task.actionStatus);
  const [category, setCategory] = useState<any>([]);
  const [users, setUsers] = useState<any>([]);
  const [status, setStatus] = useState<any>([]);
  const [priority, setPriority] = useState<any>([]);
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const ticketInitial = {
    title: "",
    description: "",
    assignedTo: "",
    dueDate: null,
    endDate: null,
    taskType: "",
    priority: "",
    isRepeated: false,
    isReminder: false,
    reminder: { type: "", value: '' },
    repeat: { type: "", value: '', data: [] },
    files: [],
    audios: [],
    images: [],
    videos: [],
  }
  const [ticketDetails, setTicketDetails] = useState<any>(ticketInitial);

  const videoRef = useRef<any>(null);

  useEffect(() => {
    dispatch(fetchTaskDataAction());
    dispatch({ type: MODAL_ACTION, payload: false })
  }, []);
  useEffect(() => {
    console.log(ticketDetails)
}, [ticketDetails]);
  useEffect(() => {
    if (actionStatus === true) {
      const closeButton = document.querySelector("#add_ticket .btn-close") as HTMLButtonElement;
      if (closeButton) {
        closeButton.click();
        setTicketDetails(ticketInitial)
      }
    }
  }, [actionStatus]);
  
  useEffect(() => {
   
    if (task) {
      setTicketDetails(task);
    }
    return () => {
      setTicketDetails(ticketInitial)
    }
  }, [task]);
  useEffect(() => {
    if (masters) {
      const categories = masters.taskTypes?.map((data: any) => ({
        value: data,
        label: data,
      })) || [];

      const statuses = masters.taskStatuses?.map((data: any) => ({
        value: data,
        label: data,
      })) || [];

      const priorities = masters.taskPriority?.map((data: any) => ({
        value: data,
        label: data,
      })) || [];

      const userOptions = masters.users?.map((data: any) => ({
        value: data.userName,
        label: data.name,
      })) || [];

      setCategory([{ value: "", label: "Select" }, ...categories]);
      setStatus([{ value: "", label: "Select" }, ...statuses]);
      setPriority([{ value: "", label: "Select" }, ...priorities]);
      setUsers([{ value: "", label: "Select" }, ...userOptions]);
    }
  }, [masters]);

  const handleSelectchange = (selectedOption: any, actionMeta: any) => {
    setTicketDetails((prevData: any) => ({
      ...prevData,
      [actionMeta.name]: selectedOption.value,
    }));
    handleValidation(actionMeta.name, selectedOption.value)
  };
  const handleChange = (e: any) => {
    const { name, value } = e.target;
    if (value !== "") {
      if (e.target.classList != undefined && e.target.classList.value.includes("highlighted-input"))
        e.target.classList.remove("highlighted-input");
    } else {
      e.target.classList.add("highlighted-input");
    }
    switch (name) {
      case "isRepeated":
        setTicketDetails((prevDetails: any) => ({
          ...prevDetails,
          [name]: e.target.checked,
          repeat: { type: "", value: 0, data: [] },
        }));
        break;
      case "isReminder":
        setTicketDetails((prevDetails: any) => ({
          ...prevDetails,
          [name]: e.target.checked,
          reminder: { type: "", value: "", data: [] },
        }));
        break;
      case "reminder":
        setTicketDetails((prevDetails: any) => ({
          ...prevDetails,
          [name]: value,
          reminder: { type: "", value: "", data: [] },
        }));
        break;
      case "repeat":
        setTicketDetails((prevDetails: any) => ({
          ...prevDetails,
          [name]: value,
          repeat: { type: "", value: 0, data: [] },
        }));
        break;
      default:
        setTicketDetails((prevDetails: any) => ({
          ...prevDetails,
          [name]: value,
        }));
        break;
    }
    handleValidation(name, value)

  };
  const handleDateChange = (e: any) => {
    const istDate = moment.tz(e, 'Asia/Kolkata');
    setTicketDetails((prevState: any) => ({
      ...prevState,
      dueDate: istDate,
    }));
    console.log(typeof istDate)

  };
  const handleValidation = (key: string, value: string) => {
    setErrors(prevErrors => {
      const updatedErrors = { ...prevErrors };

      if (value.trim()) {
        delete updatedErrors[key];
      } else {
        updatedErrors[key] = `This field is required`;
      }

      return updatedErrors;
    });
  };

  const handleSubmit = async(e: any) => {
    
    e.preventDefault();

    if (validateTask()) {
      setIsSubmitting(true);
      const formData = new FormData();
      formData.append("title", ticketDetails.title);
      formData.append("description", ticketDetails.description);
      formData.append("assignedTo", ticketDetails.assignedTo);
      formData.append("dueDate", ticketDetails.dueDate);
      formData.append("taskType", ticketDetails.taskType);
      formData.append("priority", ticketDetails.priority);
      formData.append("isRepeated", ticketDetails.isRepeated);
      formData.append("isReminder", ticketDetails.isReminder);
      if (ticketDetails.endDate)
        formData.append("endDate", ticketDetails.endDate);
      Object.keys(ticketDetails.reminder).forEach(key => {
        formData.append(`reminder.${key}`, ticketDetails.reminder[key]);
      });
      Object.keys(ticketDetails.repeat).forEach(key => {
        formData.append(`repeat.${key}`, ticketDetails.repeat[key]);
      });
      let updatedTaskFiles: { file: any; type: string }[] = [];
      (ticketDetails.files || []).forEach((file: any) => {
        updatedTaskFiles.push({ file, type: "document" });
      });
      (ticketDetails.audios || []).forEach((file: any) => {
        updatedTaskFiles.push({ file, type: "audio" });
      });
      (ticketDetails.images || []).forEach((file: any) => {
        updatedTaskFiles.push({ file, type: "image" });
      });
      (ticketDetails.videos || []).forEach((file: any) => {
        updatedTaskFiles.push({ file, type: "video" });
      });
      updatedTaskFiles.forEach((taskFile, index) => {
        formData.append(`taskFiles[${index}].file`, taskFile.file);
        formData.append(`taskFiles[${index}].type`, taskFile.type);
      });
      try {
        await dispatch(saveTaskAction(formData)); 
      } catch (error) {
        console.error("Task submission failed:", error);
      } finally {

        setTimeout(()=>{
          setIsSubmitting(false); 
        },1000)
        
      }
    }
  };

  const validateTask = () => {
    let validRequest = true;
    let newErrors: Record<string, string> = {};
    const allowedFileTypes = [
      "image/png",
      "image/jpeg",
      "application/pdf",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/vnd.ms-excel",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    ];
    const maxFileSize = 1 * 1024 * 1024;
    const optionalFields = ["audios", "videos", "images", "files"];
    const conditionalFields = ["reminder", "repeat", "images", "files", "endDate"];

    Object.keys(ticketDetails)
      .filter((ticket) => !optionalFields.includes(ticket))
      .forEach((ticket) => {
        const val = ticketDetails[ticket];

        if (conditionalFields.includes(ticket)) {
          if ((ticket === "reminder" && ticketDetails.isReminder) || (ticket === "repeat" && ticketDetails.isRepeated)) {
            if (!handleButtonError(ticket, val)) {
              const inputField = document.getElementById(ticket);
              if (inputField) {
                inputField.classList.add("highlighted-input");
                window.scrollTo(0, inputField.offsetTop - 150);
              }
              newErrors[`${ticket}type`] = "This field is required";
              validRequest = false;
            }
            if (ticket === "reminder") {
              const reminderValue = ticketDetails.reminder.value;
              if (reminderValue === null || reminderValue === undefined || reminderValue === "") {
                newErrors["remindervalue"] = "This field is required";
                validRequest = false;
              }
            } else if (ticket === "repeat") {
              if (ticketDetails.repeat.type !== "hourly" && ticketDetails.repeat.type !== "daily" && ticketDetails.repeat.data.length <= 0) {
                newErrors["repeatdata"] = "This field is required";
                validRequest = false;
              }
            }
          } else if (ticket === "endDate" && ticketDetails.isRepeated) {
            if (val === null || val === 0 || val === "") {
              newErrors[ticket] = "End Date is required";
              validRequest = false;
            }
          }
        } else {
          if (val === null || val === 0 || val === "") {
            newErrors[ticket] = "This field is required";
            validRequest = false;
          }
        }
      });
    (ticketDetails.files || []).forEach((file: File) => {
      if (!allowedFileTypes.includes(file.type)) {
        newErrors.files = "Invalid file type for attachment.";
        validRequest = false;
      } else if (file.size > maxFileSize) {
        newErrors.files = "File size for attachment must not exceed 1 MB.";
        validRequest = false;
      }
    });
    console.log(newErrors)
    setErrors(newErrors);

    return validRequest;
  };
  useEffect(() => {
    if (Object.keys(errors).length > 0) {
      const firstErrorElement = document.querySelector(".invalid-feedback");
      if (firstErrorElement) {
        firstErrorElement.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }
  }, [errors]);
  function handleButtonError(id: any, val: any) {
    const buttons = document.querySelectorAll(`#${id} button`);
    if (val?.type && val.type !== null && val.type !== "") {
      buttons.forEach((button) => {
        button.classList.remove("highlighted-input");
      });
      return true;
    }
    else {
      buttons.forEach((button) => {
        button.classList.add("highlighted-input");
      });
      const inputField = document.getElementById(id);
      if (inputField) {
        inputField.classList.add("highlighted-input");
        window.scrollTo(0, inputField.offsetTop - 150);
      }
      return false;
    }
  }

  return (
    <>
      {/* Add Ticket */}
      <div className="modal fade" id="add_ticket" data-bs-backdrop="static" data-bs-keyboard="false">
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Create Task</h4>
              <button
                type="button"
                className="btn-close custom-btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => setTicketDetails(ticketInitial)}
              >
                <i className="ti ti-x" />
              </button>
            </div>
            <form className="needs-validation" noValidate autoComplete="off">
              <div className="modal-body">
                <div className="row">
                  <div className="col-12">
                    <div className="mb-3">
                      <label className="form-label">Title <span style={{ color: 'red' }}>*</span></label>
                      <input type="text" className={`form-control ${errors.title ? "is-invalid" : ""}`} value={ticketDetails.title} name="title"
                        id="title" onChange={(e) => handleChange(e)} required />
                      {ticketDetails.title && <div className="valid-feedback" style={{ display: 'block' }}>Looks good!</div>}
                      {errors.title && <div className="invalid-feedback" style={{ display: 'block' }}>This field is required.</div>}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">Due Date <span style={{ color: 'red' }}>*</span></label>
                      <div className="input-icon-end position-relative">
                        <DatePicker id="dueDate"
                          name="dueDate"
                          value={ticketDetails.dueDate ? moment(ticketDetails.dueDate).format('YYYY-MM-DD') : ''}
                          className="form-control"
                          minDate={new Date()}
                          onChange={(event: any) => handleDateChange(event)}
                        />


                        {!errors.dueDate && <span className="input-icon-addon">
                          <i className="ti ti-calendar text-gray-7" />
                        </span>}
                      </div>
                      {ticketDetails.dueDate && <div className="valid-feedback" style={{ display: 'block' }}>Looks good!</div>}
                      {errors.dueDate && <div className="invalid-feedback" style={{ display: 'block' }}>This field is required.</div>}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">Department<span style={{ color: 'red' }}>*</span></label>
                      <Select
                        name='taskType'
                        id='taskType'
                        className={`react-select ${errors.taskType ? "is-invalid" : ""}`}
                        options={category}
                        value={category?.find((option: any) => option.value === ticketDetails.taskType) || category[0]}
                        placeholder="Select"
                        onChange={handleSelectchange}
                      />
                      {ticketDetails.taskType && <div className="valid-feedback" style={{ display: 'block' }}>Looks good!</div>}
                      {errors.taskType && <div className="invalid-feedback" style={{ display: 'block' }}>This field is required.</div>}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">Assign To <span style={{ color: 'red' }}>*</span></label>
                      <Select
                        name='assignedTo'
                        id='assignedTo'
                        className={`react-select ${errors.assignedTo ? "is-invalid" : ""}`}
                        options={users}
                        value={users?.find((option: any) => option.value === ticketDetails.assignedTo) || users[0]}
                        placeholder="Select"
                        onChange={handleSelectchange}
                      />
                      {ticketDetails.assignedTo && <div className="valid-feedback" style={{ display: 'block' }}>Looks good!</div>}
                      {errors.assignedTo && <div className="invalid-feedback" style={{ display: 'block' }}>This field is required.</div>}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="mb-3">
                      <label className="form-label">Priority <span style={{ color: 'red' }}>*</span></label>
                      <Select
                        name='priority'
                        id='priority'
                        className={`react-select ${errors.priority ? "is-invalid" : ""}`}
                        options={priority}
                        value={priority?.find((option: any) => option.value === ticketDetails.priority) || priority[0]}
                        placeholder="Select"
                        onChange={handleSelectchange}
                      />
                      {ticketDetails.priority && <div className="valid-feedback" style={{ display: 'block' }}>Looks good!</div>}
                      {errors.priority && <div className="invalid-feedback" style={{ display: 'block' }}>This field is required.</div>}
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="mb-2">
                      <label className="form-label">Description <span style={{ color: 'red' }}>*</span></label>
                      <textarea
                        value={ticketDetails.description}
                        name="description"
                        id="description"
                        onChange={handleChange}
                        className={`form-control ${errors.description ? "is-invalid" : ""}`}
                        placeholder={`Enter a detailed description of the ticket...`}
                        maxLength={999}
                        rows={3}
                      />
                      {/* <CommonTextEditor defaultValue={ticketDetails.description} defaultName={"description"}
                        classs={errors.description ? "is-invalid" : ""}
                        defaultId="description" handleInputChange={handleChange} /> */}
                      {ticketDetails.description && ticketDetails.description != "" && <div className="valid-feedback" style={{ display: 'block' }}>Looks good!</div>}
                      {errors.description && <div className="invalid-feedback" style={{ display: 'block' }}>This field is required.</div>}
                    </div>
                  </div>
                  <TaskRepetition errors={errors} task={ticketDetails} setTask={setTicketDetails} onSetReminder={handleChange} handleValidation={handleValidation} />
                  <MediaUpload data={ticketDetails} setData={setTicketDetails} />
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-light me-2"
                  data-bs-dismiss="modal"
                  onClick={() => setTicketDetails(ticketInitial)}
                >
                  Cancel
                </button>
                <button type="button" className="btn btn-primary" onClick={handleSubmit}  disabled={isSubmitting} >
                {isSubmitting ? "Submitting..." : "Create Task"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* /Add Ticket */}
    </>
  );
};

export default TicketListModal;
